/**
 * @generated SignedSource<<00117475da7e1bc9a76a12e3b138107d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditNewsTickerDefinitionForm_MessageDefinitionFragment$data = {
  readonly forwardingUrl: string | null | undefined;
  readonly id: string;
  readonly isActive: boolean | null | undefined;
  readonly text: string;
  readonly " $fragmentType": "EditNewsTickerDefinitionForm_MessageDefinitionFragment";
};
export type EditNewsTickerDefinitionForm_MessageDefinitionFragment$key = {
  readonly " $data"?: EditNewsTickerDefinitionForm_MessageDefinitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditNewsTickerDefinitionForm_MessageDefinitionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditNewsTickerDefinitionForm_MessageDefinitionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forwardingUrl",
      "storageKey": null
    }
  ],
  "type": "NewstickerMessage",
  "abstractKey": null
};

(node as any).hash = "a55e308d74ff62bcb923d8dc8012b3fb";

export default node;
